(($) => {
  $(() => {
    const $section = $('.section--search-results');

    if ($section.length) {
      const $searchForm = $section.find('.search-form');
      const $queryInput = $searchForm.find('#search-results__query');
      const $close = $searchForm.find('.btn-close');
      const $searchResults = $section.find('.search-results');

      /**
       * When the query input is focused, publish the 'search_initiate' analytics event.
       */
      $queryInput.on('focus', () => {
        Shopify.analytics.publish('search_initiate');
      });

      /**
       * When the close button is clicked, empty and focus the query input.
       */
      $close.on('click', () => {
        $queryInput.val('').trigger('focus');
      });

      /**
       * Cache the search terms the results were originally based on.
       */
      const searchTerms = $queryInput.val();

      if (searchTerms) {
        /**
         * If a search was performed (i.e. search terms exist),
         * publish the 'search_results_returned' analytics event
         * containing the user's query and total results.
         */
        Shopify.analytics.publish('search_results_returned', {
          search_term: searchTerms,
          search_results: $searchResults.length ? $searchResults.data('total-results') : 0,
        });
      }

      if ($searchResults.length) {
        /**
         * When a product card (search result) is clicked, publish the 'search_results_click'
         * analytics event before proceeding to redirect the user to the intended URL.
         */
        $searchResults.on('click', '.product__card a[href]', (e) => {
          e.preventDefault();

          const $a = $(e.currentTarget);

          Shopify.analytics.publish('search_results_click', {
            search_term: searchTerms,
            result_type: 'organic',
            suggested_term: 'n/a',
            suggestion_category: 'n/a',
            suggestion_type: 'product card',
          });

          window.location.href = $a.attr('href');
        });
      }
    }
  });
})(jQuery);